export default __webpack_public_path__ + "static/media/Nacht.0d5a30b2.jpeg";